<template>
    <v-layout>
        <v-flex>
            <v-card>   
                <v-card-title >
                    Product Category Creation {{ $route.params.id }}                 </v-card-title>
                <v-card-text>
                    <v-form>
                    <v-text-field label="Name" ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success"><v-icon left>save</v-icon>Save</v-btn>
                </v-card-actions>
            </v-card>    
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    watch: {
        '$route' (to, from ) {
            alert('hi ' + to.params.id)
        }
       
    },
    data(){
        return {
            
        }
    },
    computed: {
        msg() {
            console.log(this.editmode)
        }
        
    },
    created() {
        alert(this.$route.params)
        console.log( this.$route.path)
    }
   

}
</script>

<style>

</style>
